module.exports = __webpack_public_path__ + "img/sy.58c72bb7.png";